import Cookies from 'js-cookie';
import { getJwtExpMs } from './common/jwt';

const ACCESS_TOKEN_NAME = 'accessToken';

export function storeAccessToken(token: string) {
	const expMs = getJwtExpMs(token);
	const options: Cookies.CookieAttributes = {
		secure: process.env.NODE_ENV === 'production',
		sameSite: 'lax',
	};
	if (expMs !== null) {
		options.expires = new Date(expMs);
	} else {
		options.expires = 1;
	}
	Cookies.set(ACCESS_TOKEN_NAME, token, options);
}

export function removeAccessToken() {
	Cookies.remove(ACCESS_TOKEN_NAME);
}

export function getAccessToken(): string | null {
	return Cookies.get(ACCESS_TOKEN_NAME) ?? null;
}
